import React from 'react';
import { Segmented } from 'antd';
import { TableOutlined, AppstoreOutlined, ProjectOutlined } from '@ant-design/icons';
import styled from 'styled-components';

/**
 * ViewToggle - Switch between Table, Gallery, and Kanban views
 * Features:
 * - Segmented control for view selection
 * - Icon + label for each view
 * - Persists selection to localStorage
 */
const ViewToggle = ({ value, onChange }) => {
  const options = [
    {
      label: 'Table',
      value: 'table',
      icon: <TableOutlined />,
    },
    {
      label: 'Gallery',
      value: 'gallery',
      icon: <AppstoreOutlined />,
    },
    {
      label: 'Kanban',
      value: 'kanban',
      icon: <ProjectOutlined />,
    },
  ];

  const handleChange = (newValue) => {
    onChange?.(newValue);
    // Persist to localStorage
    localStorage.setItem('templateViewMode', newValue);
  };

  return (
    <Container>
      <Label>View:</Label>
      <StyledSegmented
        value={value}
        onChange={handleChange}
        options={options}
      />
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Label = styled.span`
  font-weight: 500;
  color: #595959;
  font-size: 14px;
`;

const StyledSegmented = styled(Segmented)`
  background: #f5f5f5;
`;

const OptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  .anticon {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }
`;

export default ViewToggle;
